module.exports = __webpack_public_path__ + "img/python.28a7949b.png";